export class Usuario {
    constructor() {
        this.username = '';
        this.nombre = '';
        this.apellido = '';
        this.email = '';
        this.password = '';
        this.password_re = '';
        this.delegaciones = [];
        this.rol = '';
    }
}


// WEBPACK FOOTER //
// ./src/model/Usuario.js